import { Box } from '@mui/material';
import { useState } from 'react';
import { SketchPicker } from 'react-color';

interface SketcherProps {
  hexadecimal: string;
  setHexadecimal: (hex: string) => void;
  setIsSkecthOpen: (isOpen: boolean) => void;
  onPickColor: (color: string) => void;
}

function Sketcher({
  hexadecimal,
  setHexadecimal,
  setIsSkecthOpen,
  onPickColor,
}: SketcherProps) {
  const [tempHexadecimal, setTempHexadecimal] = useState<string>(hexadecimal);

  const handleSave = () => {
    setHexadecimal(tempHexadecimal);
    onPickColor(tempHexadecimal);
    setIsSkecthOpen(false);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: 1,
          backgroundColor: '#f5f5f5',
          border: '1px solid #ccc',
          borderRadius: '2px',
        }}
      >
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => {
            setIsSkecthOpen(false);
          }}
        >
          キャンセル
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSave}
        >
          保存
        </button>
      </Box>

      <SketchPicker
        color={tempHexadecimal}
        onChange={(color) => {
          setTempHexadecimal(color.hex);
        }}
        width="97%"
      />
    </Box>
  );
}

export default Sketcher;
